export const SELECT_FIRST_PAGE = 1
export const SELECT_PAGE_SIZE = 20
